import { Text } from '@huspy/briks-web';
import { Skeleton, Tooltip } from '@mantine/core';
import { shortenNumber } from '@modules/dashboard/utils';
import { formatNumber } from '@shared/utils';

type Props = {
  skeleton?: boolean;
  number?: number;
  currency?: string;
};

const DisplayNumber = ({ skeleton, number, currency }: Props) => {
  if (skeleton) {
    return (
      <Skeleton data-testid='display-number-skeleton' h={ 28 } w={ 120 } />
    );
  }

  return (
    <Text size='2xl' fontWeight={ 600 } cursor='pointer' w='fit-content'>
      <Tooltip.Floating label={ `${currency ?? ''} ${formatNumber(number)}` }>
        <span>
          {`${currency ?? ''} ${shortenNumber(number ?? 0)}`}
        </span>
      </Tooltip.Floating>
    </Text>
  );
};

export default DisplayNumber;
